import { render } from "./EditCategorieArticlePage.vue?vue&type=template&id=05ce4be2&ts=true"
import script from "./EditCategorieArticlePage.vue?vue&type=script&lang=ts"
export * from "./EditCategorieArticlePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__